<template>
  <div>
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div
      style="box-shadow: 0px 2px 20px 0px #105c8e26"
      class="bg-white px-10 py-5 rounded-2xl"
    >
      <!-- <h3 class="text-lg font-semibold text-blues mb-2">Staff Upload Form</h3> -->
      <form @submit.prevent="handleSubmit" class="space-y-4" ref="addRefs">
        <!-- Name -->
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div>
            <label
              for="firstName"
              class="block text-sm font-medium text-gray-700 mb-1"
              >First Name<span class="text-red-400 pl-1">*</span></label
            >
            <input
              id="firstName"
              type="text"
              placeholder="First Name"
              v-model="firstName"
              class="w-full p-2 border border-gray-300 rounded"
              required
            />
          </div>
          <div>
            <label
              for="lastName"
              class="block text-sm font-medium text-gray-700 mb-1"
              >Last Name</label
            >
            <input
              id="lastName"
              type="text"
              placeholder="Last Name"
              v-model="lastName"
              class="w-full p-2 border border-gray-300 rounded"
            />
          </div>
          <!-- Email -->
          <div>
            <label
              for="email"
              class="block text-sm font-medium text-gray-700 mb-1"
              >Email ID<span class="text-red-400 pl-1">*</span></label
            >
            <input
              id="email"
              type="email"
              placeholder="Email ID"
              v-model="email"
              @input="email = email.toLowerCase()"
              class="w-full p-2 border border-gray-300 rounded"
              required
            />
          </div>
          <div>
            <label class="block font-medium text-gray-700 mb-1"
              >Password<span class="text-red-400 pl-1">*</span></label
            >
            <div class="flex gap-4 mb-2">
              <label class="flex items-center space-x-2 cursor-pointer">
                <input
                  type="radio"
                  id="passwordCustom"
                  value="custom"
                  v-model="passwordOption"
                  class="form-radio text-blue-500"
                />
                <span>Custom</span>
              </label>
              <label class="flex items-center space-x-2 cursor-pointer">
                <input
                  type="radio"
                  id="passwordAuto"
                  value="auto"
                  v-model="passwordOption"
                  class="form-radio text-blue-500"
                />
                <span>Auto Generate</span>
              </label>
            </div>

            <div v-if="passwordOption === 'custom'">
              <label
                for="password"
                class="block text-sm font-medium text-gray-700 mb-1"
                >Custom Password
              </label>
              <input
                id="password"
                type="password"
                placeholder="Enter Password"
                v-model="password"
                class="w-full p-2 border border-gray-300 rounded"
                required
              />
            </div>

            <div v-if="passwordOption === 'auto'">
              <label
                for="password"
                class="block text-sm font-medium text-gray-700 mb-1"
                >Generated Password</label
              >
              <input
                id="password"
                type="text"
                :value="password"
                readonly
                class="w-full p-2 border border-gray-300 rounded bg-gray-100"
              />
            </div>
          </div>
          <div class="mt-auto">
            <label
              for="countryCode"
              class="block text-sm font-medium text-gray-700 mb-1"
              >Mobile Number</label
            >
            <div class="flex">
              <select
                id="country-form"
                v-model="countryCode"
                @change="setPhoneLength(countryCode)"
                required
                class="w-20 px-3 py-2 border border-gray-300 rounded"
              >
                <option value="" disabled>Select an option</option>
                <option
                  v-for="country in countryCodes"
                  :key="country.code"
                  :value="country.code"
                >
                  {{
                    countryCode === country.code
                      ? country.code
                      : `${country.name} (${country.code})`
                  }}
                </option>
              </select>
              <input
                type="tel"
                v-model="mobile"
                required
                class="w-full p-2 border border-gray-300 rounded"
                onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                id="Phone_no"
                placeholder="Phone no"
                :maxlength="max_length"
              />
            </div>
            <span class="text-xs font-normal" v-if="phone_max_length"
              >Please Enter
              <b>{{ phone_max_length }}</b>
              Digit Phone Number</span
            >
          </div>

          <div class="mt-auto">
            <label
              for="selectField"
              class="block text-sm font-medium text-gray-700 mb-1"
            >
              Role
              <span class="text-red-400">*</span></label
            >
            <select
              v-if="rols"
              id="selectField"
              v-model="role"
              class="w-full p-2 border border-gray-300 rounded"
              required
            >
              <option value="" disabled selected>Select Role</option>
              <option
                v-for="rol in rols.filter((r) => r.permission !== 'student')"
                :key="rol.id"
                :value="rol.id"
              >
                {{ rol.permission }}
              </option>
            </select>
          </div>
          <div v-if="selectedRoleName && selectedRoleName !== 'instructor'">
            <label
              for="selectField"
              class="block text-sm font-medium text-gray-700 mb-1"
            >
              Program <span class="text-red-400">*</span>
            </label>
            <select
              id="selectField"
              v-model="Program"
              @change="getProgramsFilter(Program)"
              class="w-full p-2 border border-gray-300 rounded"
              required
            >
              <option value="" disabled selected>Select Program</option>
              <option
                v-for="program in programs"
                :key="program.id"
                :value="program.id"
              >
                {{ program.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="flex justify-end">
          <!-- <button
            type="submit"
            class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            Submit
          </button> -->
          <div class="flex items-center gap-3">
            <button
              type="submit"
              :disabled="disable_submit == true"
              :class="
                this.disable_submit == true
                  ? 'bg-gray-200 text-black cursor-not-allowed'
                  : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
              "
              class="rounded-lg text-sm px-6 py-2"
            >
              Submit
            </button>
            <img
              v-if="disable_submit"
              src="@/assets/loading.gif"
              alt="loading"
              class="w-6 h-6 object-contain"
            />
          </div>
        </div>
      </form>

      <!-- <div class="flex items-center justify-center pt-3 w-full">
          <div class="w-full border border-gray-400 h-0"></div>
          <div class="px-3 text-black">or</div>
          <div class="w-full border border-gray-400 h-0"></div>
        </div> -->

      <!-- <form @submit.prevent="handleSubmitcsv" class="space-y-4" ref="clearRef">
     
        <div class="flex flex-col gap-3 w-full">
          <div class="flex justify-between">
            <label for="attachments" class="text-left flex items-center"
              >Bulk Upload *
              <div class="relative group">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-pointer"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-6a.75.75 0 011.5 0v1.25a.75.75 0 01-1.5 0V12zm0-6a.75.75 0 011.5 0v3a.75.75 0 01-1.5 0V6z"
                    clip-rule="evenodd"
                  />
                </svg>
                <div
                  class="absolute z-10 hidden group-hover:block w-48 rounded bg-gray-800 p-2 text-xs text-white top-5 left-16 -translate-x-1/2"
                >
                  Only CSV files in the sample format are allowed.
                </div>
              </div>
            </label>
            <div class="w-[20%] flex justify-center items-center">
              <a
                href="https://muonlms-api.galecta.com/media/uploaded_videos/staff_bulk_AYOoS57.csv"
                download
                class="w-full flex gap-1 items-center justify-center tooltip"
              >
                <img
                  src="@/assets/newd/download.png"
                  alt="download file"
                  class="w-4 h-4 object-contain"
                />
                <span class="tooltiptext text-xs w-full"> Sample File</span>
              </a>
            </div>
          </div>
          <input
            id="source"
            type="file"
            class="bg-gray-100 py-2 px-2 w-full rounded text-xs md:text-sm lg:text-base"
            @change="inputchange"
            
          />
        </div>

        <div class="flex justify-end">
          <button
            type="submit"
            class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            Submit
          </button>
        </div>
      </form> -->
    </div>
    <div class="flex items-center justify-between mt-6 mb-4">
      <div class="flex items-center gap-2">
        <h2 class="text-lg font-semibold mb-4">Submitted Data</h2>
        <span v-if="totalcount" class="mb-3"> ({{ totalcount || 0 }}) </span>
      </div>

      <div class="relative w-full md:max-w-80">
        <div
          class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 text-gray-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
        </div>
        <input
          type="text"
          v-model="searching"
          @input="getsubmit(1)"
          placeholder="Search..."
          class="w-full rounded-xl border border-gray-200 bg-white pl-10 pr-10 py-2 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
        />
        <button
          v-if="searching"
          @click="clearSearch"
          class="absolute inset-y-0 right-0 pr-3 flex items-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 text-gray-400 hover:text-gray-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
    </div>
    <div v-if="submittedData.length > 0">
      <div
        class="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-x-auto"
      >
        <table class="min-w-full text-sm">
          <thead class="bg-gray-100 whitespace-nowrap">
            <tr>
              <th
                class="py-3 px-4 border-b border-r font-semibold text-blues text-left"
              >
                S.NO
              </th>

              <th
                class="py-3 px-4 border-b border-r font-semibold text-blues text-left"
              >
                First Name
              </th>
              <th
                class="py-3 px-4 border-b border-r font-semibold text-blues text-left"
              >
                Last Name
              </th>

              <th
                class="py-3 px-4 border-b border-r font-semibold text-blues text-left"
              >
                Mobile No
              </th>

              <th
                class="py-3 px-4 border-b border-r font-semibold text-blues text-left"
              >
                Email
              </th>

              <th
                class="py-3 px-4 border-b border-r font-semibold text-blues text-left"
              >
                Role
              </th>
              <th class="py-3 px-4 border-b font-semibold text-blues text-left">
                Created Date
              </th>
            </tr>
          </thead>

          <tbody class="divide-y divide-gray-100 bg-white">
            <tr
              v-for="(item, index) in submittedData"
              :key="index"
              class="hover:bg-gray-50 transition whitespace-nowrap"
            >
              <td class="py-2 px-4 border-r text-gray-700">
                {{ (currentPage - 1) * pageSize + index + 1 }}
              </td>

              <td
                class="py-2 px-4 border-r text-xs text-gray-500 font-medium uppercase"
              >
                {{ item.first_name || "NA" }}
              </td>
              <td class="py-2 px-4 border-r text-xs text-gray-500 font-medium">
                {{ item.last_name || "NA" }}
              </td>

              <td class="py-2 px-4 border-r text-xs text-gray-500 font-medium">
                {{ item.phone_number || "NA" }}
              </td>

              <td class="py-2 px-4 border-r text-xs text-gray-500 font-medium">
                {{ item.email || "NA" }}
              </td>

              <td class="py-2 px-4 text-xs border-r text-gray-500 font-medium">
                {{ item.role || "NA" }}
              </td>
              <td class="py-3 px-4 text-left text-xs text-gray-500 font-medium">
                {{ item.created_at ? formatDate(item.created_at) : "NA" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <!-- <div class="pb-5 flex items-center justify-center">
          <Pagination :totalPages="totalPages" @page-changed="getsubmit" />
        </div> -->
      <div
        class="flex flex-col sm:flex-row justify-center gap-3 pb-[20px] relative"
      >
        <!-- PAGE SIZE -->
        <div
          class="md:absolute md:left-3 md:top-4 gap-2 text-sm text-gray-600 flex justify-center items-center md:flex-none md:justify-normal"
        >
          <span class="flex md:hidden">Rows per page:</span>
          <select
            v-model="pageSize"
            @change="onPageSizeChange"
            class="border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option :value="10">10</option>
            <option :value="20">20</option>
            <option :value="50">50</option>
            <option :value="100">100</option>
          </select>
        </div>

        <!-- PAGINATION -->
        <div v-if="totalPages > 1" class="flex justify-center">
          <Pagination
            :totalPages="totalPages"
            ref="paginationRef"
            @page-changed="getsubmit"
          />
        </div>
      </div>
    </div>

    <div v-else class="text-center text-gray-500 py-6">No Data Found</div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import countryCodeMixins from "@/mixins/countryCodeMixins";
import phoneLength from "@/mixins/phoneLength";
import FlashMessage from "@/components/FlashMessage.vue";
import Pagination from "@/components/Pagination.vue";

export default {
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      countryCode: "+91",
      phone_max_length: "",
      mobile: "",
      passwordOption: "custom",
      password: "",
      role: "",
      max_length: 10,
      rols: [],
      searching: "",
      submittedData: [],

      messages: {
        text: "",
        type: "null",
      },
      totalPages: 1,
      currentPage: 1,
      pageSize: 10,
      totalcount: "",
      disable_submit: false,
      Program: "",
      department: "",
      programs: [],
      departments: [],
    };
  },

  components: {
    FlashMessage,
    Pagination,
  },

  mixins: [countryCodeMixins, phoneLength],
  watch: {
    passwordOption(newVal) {
      if (newVal === "auto") {
        this.password = this.generatePassword();
      } else {
        this.password = "";
      }
    },
  },
  computed: {
    ...mapGetters(["userInfo"]),
    selectedRoleName() {
      const selectedRole = this.rols.find((r) => r.id === this.role);

      return selectedRole?.permission?.toLowerCase() || "";
    },
  },
  async created() {
    this.getPrograms();
    this.getrole();
    this.getsubmit(1);
  },
  mounted() {},
  methods: {
    clearSearch() {
      this.searching = "";
      this.getsubmit(1);
    },
    getPrograms() {
      axios
        .get(
          `${process.env.VUE_APP_API}/program-list/?Key=${this.userInfo.token_key}`,
        )
        .then((res) => {
          this.programs = res.data.data;
        });
    },
    getProgramsFilter(program_id) {
      axios
        .get(
          `${process.env.VUE_APP_API}/department-list/?Key=${this.userInfo.token_key}&program__id=${program_id}`,
        )
        .then((res) => {
          // this.departments = res.data.data;
          this.departments = res.data.data.map((item) => ({
            id: item.id,
            name: item.name,
          }));
          if (this.departments.length > 0) {
            this.department = this.departments[0].id;
          }
          console.log("Departments:", this.department);
        });
    },
    onPageSizeChange() {
      this.currentPage = 1;
      if (this.$refs.paginationRef) {
        this.$refs.paginationRef.currentPage = 1;
      }
      this.getsubmit(1);
    },
    formatDate(date) {
      if (!date) return "";

      const d = new Date(date);

      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");

      let hours = d.getHours();
      const minutes = String(d.getMinutes()).padStart(2, "0");
      const seconds = String(d.getSeconds()).padStart(2, "0");

      const ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12 || 12;
      hours = String(hours).padStart(2, "0");

      return `${yyyy}-${mm}-${dd}, ${hours}:${minutes}:${seconds} ${ampm}`;
    },
    handleSubmitcsv(el) {
      let formData = new FormData();
      // formData.append("title", el.target.elements.file_title.value);
      // formData.append("description", el.target.elements.file_description.value);
      formData.append("file", el.target.elements.source.files[0]);

      axios
        .post(
          `${process.env.VUE_APP_API}/enrollement-bulk-csv-upload/?Key=${this.userInfo.token_key}`,
          formData,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.getsubmit(1);
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.$refs.clearRef.reset();
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },

    generatePassword() {
      return Math.random().toString(36).slice(-8);
    },
    getrole() {
      axios
        .get(
          `${process.env.VUE_APP_API}/permission-list/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.rols = response.data.data;
            // this.rols = response.data.data.filter(role => role.permission != 'student');
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleSubmit() {
      this.disable_submit = true;
      const beforeData = {
        first_name: this.firstName,
        last_name: this.lastName,
        email: this.email,
        custom_password: this.password,
        auto_generative_password: this.password,
        country_code: this.countryCode,
        phone_number: this.countryCode + " " + this.mobile,
        role: this.role,
        program: this.Program,
        department: this.department,
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/user/signup/?Key=${this.userInfo.token_key}`,
          beforeData,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            this.getsubmit(1);
            // this.$refs.addRefs.reset();

            this.firstName = "";
            this.lastName = "";
            this.email = "";
            this.password = "";
            this.passwordOption = "custom";
            this.countryCode = "+91";
            // this.countryCode = "";
            this.mobile = "";
            this.role = "";
            this.Program = "";
            this.department = "";
            this.disable_submit = false;
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            this.disable_submit = false;
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        })
        .finally(() => {
          this.disable_submit = false;
        });
    },
    getsubmit(number) {
      this.currentPage = number;
      axios
        .get(
          `${process.env.VUE_APP_API}/staff-enrollment-list/?Key=${this.userInfo.token_key}&page=${number}&page_size=${this.pageSize}&search=${this.searching}`,
        )
        .then((response) => {
          if (response.data.data.status == 200) {
            this.totalPages = response.data.total_page;
            this.submittedData = response.data.data.data;
            this.totalcount = response.data.total;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
/* tool tip  */
.tooltip {
  position: relative;
  display: inline-block;
  /* border-bottom: 1px dotted black; */
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 40%;
  /* background-color: #17469E; */
  /* color: #fff; */
  color: #17469e;
  text-align: center;
  border: 1px solid #17469e;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  bottom: -8px;
  left: 20px;
  z-index: 1;
}
.wrapper-class {
  max-width: 200px;
  word-wrap: break-word;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>
